import { useEffect } from 'react';
import { useLocation } from 'wouter';

import { PublicShell } from '@/components/public-shell';
import { useGeographyContext } from '@/hooks/useGeographyContext';

export default function Classes() {
  const [, navigate] = useLocation();
  const { regionSlug, localitySlug } = useGeographyContext();

  useEffect(() => {
    const nextPath = localitySlug
      ? `/regions/${regionSlug}/${localitySlug}/classes`
      : `/regions/${regionSlug}/classes`;
    navigate(nextPath, { replace: true });
  }, [localitySlug, navigate, regionSlug]);

  return (
    <PublicShell routeKey="classes">
      <div className="page-shell flex min-h-[60vh] items-center justify-center">
        <div className="animate-spin w-8 h-8 border-4 border-primary border-t-transparent rounded-full"></div>
      </div>
    </PublicShell>
  );
}
